<div provide-parent-form class="cycle-edit" *ngIf="cycle">
	<div class="cycle-cols">
		<div class="cycle-col">
			<bb-form-element [form]="form" label="{{'CYCLE_NAME' | translate}}">
				<input [(ngModel)]="cycle.label" type="text" name="cycle_label" />
			</bb-form-element>
			<bb-form-element [form]="form" label="{{'RUN_FROM' | translate}}">
				<div class="input from-to">
					<bb-timecode-editor
						class="ft"
						[forceHourDisplay]="true"
						[hideSeconds]="true"
						[min]="min"
						[max]="(cycle.to < max ? cycle.to : max) - minDuration"
						[(ngModel)]="cycle.from"
						name="cycle_from"
						(ngModelChange)="propagate()"
					></bb-timecode-editor>
					<div class="ft">
						{{ 'TO' | translate }}
					</div>
					<bb-timecode-editor
						class="ft"
						[forceHourDisplay]="true"
						[hideSeconds]="true"
						[min]="(cycle.from > min ? cycle.from : min) + minDuration"
						[max]="max"
						[(ngModel)]="cycle.to"
						name="cycle_to"
						(ngModelChange)="propagate()"
					></bb-timecode-editor>
				</div>
			</bb-form-element>
			<bb-form-element [form]="form" [label]="'FILLER_ITEM' | translate">
				<bb-entity-selector 
					[(ngModel)]="cycle.fillerItemId"
					class="item-action"
					name="fillerItem"
					[filterSet]="fillerFilterSet"
					[placeholder]="'Select filler'"
					[entityType]="'search'"
					(ngModelChange)="onFillerItemChange($event)"
					(optionSelected)="onFillerItemSelected($event)"
				></bb-entity-selector>
			</bb-form-element>
		</div>
		<div class="cycle-col">
			<bb-form-element [form]="form" [label]="'FIXED_LENGTH' | translate">
				<bb-check [(ngModel)]="cycle.isFixedLength" name="cycle_isFixedLength"></bb-check>
			</bb-form-element>
	
			<bb-form-element [form]="form" [label]="'LOOP_TIME' | translate" *ngIf="cycle.isFixedLength">
				<bb-timecode-editor
					[min]="600"
					[(ngModel)]="cycle.loopTimeSeconds"
					name="cycle_loopTimeSeconds"
					(ngModelChange)="propagate()"
				></bb-timecode-editor>
			</bb-form-element>
		</div>
	</div>
	<div class="cycle-items">
		<div class="loading-items" *ngIf="loadingItems">
			<bb-loading></bb-loading>
		</div>
		<div class="list-container" [hidden]="loadingItems">
			<strong class="no-items" *ngIf="!cycleItems?.length">
				{{ 'NO_ITEMS_YET' | translate }}
			</strong>
			<bb-table-container cdkDropList (cdkDropListDropped)="itemDragged($event)" *ngIf="cycleItems?.length">

				<bb-table-header [configurable]="false">
					<bb-table-header-cell [hideSorting]="true" property="bars"></bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="order"></bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="type"></bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="title" class="overflow">{{ 'TITLE' | translate }}</bb-table-header-cell>
					<bb-table-header-cell [hideSorting]="true" property="status" class="icon">&nbsp;</bb-table-header-cell>
					<bb-table-header-cell class="buttons"></bb-table-header-cell>
				</bb-table-header>
		
				<ng-container *ngFor="let item of cycleItems; let i = index; trackBy: trackBy;">
					<bb-table-row
						*ngIf="item"
						cdkDrag
						cdkDragLockAxis="y"
						[cdkDragDisabled]="item.id === cycle.fillerItemId"
						[class.is-filler]="item.id === cycle.fillerItemId"
						[colspan]="10"
					>
						<bb-table-cell
							cdkDragHandle
							property="bars"
							[class.north-south]="item.id !== cycle.fillerItemId"
							[title]="item.id === cycle.fillerItemId ? ('FILLER_ITEM' | translate) : ''"
						>
							<i class="fa" [class.fa-bars]="item.id !== cycle.fillerItemId" [class.fa-step-forward]="item.id === cycle.fillerItemId"></i>
						</bb-table-cell>
						<bb-table-cell cdkDragHandle property="order">
							<span *ngIf="i === cycleItems.length - 1" class="infinity" title="The last item will be looped until the next cycle starts.">
								∞
							</span>
							<span *ngIf="i !== cycleItems.length - 1">
								{{ i + 1 }}.
							</span>
						</bb-table-cell>
						<bb-table-cell cdkDragHandle property="type">
							<span [innerHTML]="item | clipIcon"></span>
							<span class="extra-type">
								<!-- isSlideshow doesn't work yet, doesn't appear in solr search -->
								<i *ngIf="item.isSlideshow" [title]="'SLIDESHOW' | translate" class="fa fa-image"></i>
								<i *ngIf="item.sourcetype === 'live'" [title]="'LIVE' | translate" class="fa fa-feed"></i>
							</span>
						</bb-table-cell>
						<bb-table-cell cdkDragHandle property="title" class="overflow"><span [attr.title]="item?.title" [innerHTML]="item?.title"></span></bb-table-cell>
						<bb-table-cell cdkDragHandle property="status"><span [innerHTML]="item | statusIcon"></span></bb-table-cell>
						<bb-table-cell cdkDragHandle class="buttons">
			
							<a class="button" (click)="onRemoveItemClicked(i)">
								<i class="fa fa-chain-broken"></i>
							</a><!--
			
							--><a class="button" [ngClass]="{'disabled': !item?.id}" (click)="editEntity(item)">
								<i class="fa fa-edit"></i>
							</a>
			
						</bb-table-cell>
					</bb-table-row>
				</ng-container>
		
			</bb-table-container>
		</div>
	</div>
	<div class="item-actions">
		<bb-entity-selector class="item-action" [filterSet]="itemFilterSet" [selectOnly]="true" [placeholder]="'Add existing'" [icon]="'chain'" [entityType]="'search'" (optionSelected)="onItemSelected($event)"></bb-entity-selector>
		<div class="button item-action" (click)="addNewPlaylist('dynamic')">
			{{ 'ADD_NEW_SMART_PLAYLIST' | translate }}
		</div>
		<div class="button item-action" (click)="addNewPlaylist('static')">
			{{ 'ADD_NEW_STATIC_PLAYLIST' | translate }}
		</div>
	</div>
	<div class="action-bar">
		<span class="button" (click)="onDeleteClick()"><i class="fa fa-trash"></i>{{ 'DELETE' | translate }}</span>
	</div>
</div>
